import { createFileRoute } from '@tanstack/react-router';
import { BroadcastDetailPage } from '@web/modules/campaigns/broadcasts/detail/broadcast-detail-page';

export const Route = createFileRoute('/_app/campaigns/broadcasts/$broadcastId')({
  component: BroadcastDetailRoute,
});

function BroadcastDetailRoute() {
  const { broadcastId } = Route.useParams();
  return <BroadcastDetailPage broadcastId={broadcastId} />;
}
